function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from "prop-types";
import React, { Component } from "react";
import classnames from "classnames";
import { importCssVariables } from "@brandwatch/axiom-materials";
import "./globals.css";
importCssVariables();
import "./Base.css";
const underlineTextSizes = new Set(["display2", "display1", "headline", "body"]);
/**
 * Internally nearly all components in Axiom render Base. Base is used to share common styles.
 * You can also use it in projects that use Axiom as an alternative the exported Axiom CSS variables.
 * As most components render Base you can pass props to it indirectly.
 */

export default class Base extends Component {
  render() {
    const {
      Component,
      className,
      cloak,
      cloakContainer,
      container,
      hiddenUntil,
      pointerEventsDisabled,
      space,
      sticky,
      textBreak,
      textCase,
      textCenter,
      textColor,
      textEllipsis,
      textEmphasize,
      textLeft,
      textSize,
      textRight,
      textStrike,
      textStrong,
      textUnderline,
      textFace,
      theme,
      visibleUntil,
      baseRef,
      ...rest
    } = this.props;
    const underline = textUnderline && underlineTextSizes.has(textSize || "body") && (textSize || "body");
    const classes = classnames(className, {
      "ax-cloak": cloak !== undefined,
      "ax-cloak--visible": cloak === false,
      "ax-cloak__container": cloakContainer,
      "ax-container": container,
      [`ax-hidden-until--${hiddenUntil}`]: hiddenUntil,
      [`ax-visible-until--${visibleUntil}`]: visibleUntil,
      [`ax-space--${space}`]: space,
      "ax-sticky": sticky,
      [`ax-text--case-${textCase}`]: textCase,
      "ax-text--align-center": textCenter === true,
      [`ax-text--align-center--${textCenter}`]: textCenter && textCenter !== true,
      [`ax-text--break-${textBreak}`]: textBreak,
      [`ax-text--color-${textColor}`]: textColor,
      "ax-text--ellipsis": textEllipsis,
      "ax-text--emphasize": textEmphasize,
      "ax-text--align-left": textLeft === true,
      [`ax-text--align-left--${textLeft}`]: textLeft && textLeft !== true,
      "ax-text--align-right": textRight === true,
      [`ax-text--align-right--${textRight}`]: textRight && textRight !== true,
      [`ax-text--size-${textSize}`]: textSize,
      "ax-text--strike": textStrike,
      "ax-text--strong": textStrong,
      [`ax-text--underline-${underline}`]: underline,
      [`ax-text--face-${textFace}`]: !!textFace,
      [`ax-theme--${theme}`]: theme,
      "ax-pointer--disabled": pointerEventsDisabled
    });

    if (sticky) {
      rest.style = { ...rest.style,
        top: sticky
      };
    }

    return /*#__PURE__*/React.createElement(Component, _extends({}, rest, {
      className: classes,
      ref: baseRef
    }));
  }

}

_defineProperty(Base, "defaultProps", {
  Component: "div"
});